module.exports = __webpack_public_path__ + "media/images/smart_phone/check-271576f08c26ae979e7af21c51802e96.png";